import { useRouter } from 'next/router';
import { getImageForWidgetNews } from "helpers";

export const useTag = (props) => {

    const { content, ...rest } = props;

    const router = useRouter();

    const sectionNameAds = rest?.properties?.name?.replace(/\s+/g, "-")?.toLowerCase();

    const currentUrl = router?.asPath;

    const adsPath = "tags/home";

    const listado = {
        pagination: rest?.pagination,
        result: content,
        template: "destacadaPlus",
        widgets: rest?.widgets ?? [],
        withBanner: true,
        total: rest?.pagination?.total,
        adsPath,
        withPaginate: true,
    };

    const bucketsHeader = (rest?.properties?.bucketsHeader)
        ? rest.properties.bucketsHeader
        : { liveblogs: [], urgent: [] };

    const menu = rest?.menu ?? {};

    const title = rest?.properties?.name ?? "Tag";

    const urlBreadCrumbTags = rest?.properties?.slug ?? "";

    const url = !!urlBreadCrumbTags 
        ? `tag/${urlBreadCrumbTags}.html` 
        : "#";

    const metaTitle = rest?.properties?.metadata?.title ?? title;

    const metaDescription =
        rest?.properties?.metadata?.metaDescription ??
        `Mirá las últimas noticias y novedades relacionadas a ${metaTitle} en Clarín.com. Noticias de la Argentina y el mundo. Información actualizada las 24 horas y en español. Informate ya.`;

    const description = rest?.properties?.description ?? "";

    const sectionData = { name: title, url: url };

    const dataAnalitics = {
        pageType: "otros",
        nsSite: "clarin",
        publishedDate: rest?.properties?.publishedDate ?? new Date(),
    };

    const dataMeter = {
        pageType: "portada",
        authors: null,
        paywall: "free",
        sectionNames: rest?.properties?.name,
        section: rest?.properties?.name,
    };

    const imagesRelated = rest?.properties?.related?.image?.length
        ? rest.properties.related.image
        : [];

    const tagsRelated =  rest?.properties?.related?.tags?.length
        ?  rest.properties.related.tags
        : [];

    const manualTagsRelated = rest?.properties?.related?.manualTags?.length
        ? rest.properties.related.manualTags
        : [];

    let urlCanonical = currentUrl?.includes(".html") 
        ? currentUrl.replace('/', '') 
        : currentUrl.replace('/', '') + ".html";

    urlCanonical = urlCanonical.includes("/page/") 
        ? urlCanonical.replace('.html', '') 
        : urlCanonical; 
 
    let imageWeb = null;

    if(content?.[0]){

        const clippings = {
            desktop: ["rectangle_sm","16_9_medianas","2_1_S2"],
            mobile: ["rectangle_lg","rectangle_sm","16_9_medianas","2_1_S2"],
        }

        if(content?.[0]?.selectedClippingId){
            clippings.desktop = [content?.[0].selectedClippingId, ...clippings.desktop];
            clippings.mobile = [content?.[0].selectedClippingId, ...clippings.mobile];
        }

        imageWeb = getImageForWidgetNews({
            clippingsRequired: clippings,
            images: content?.[0]?.images?.[0]?.clippings,
            selectedImageId: content?.[0]?.selectedImageId,
            customClippings: content?.[0]?.customClippings,
            croppedImages: content?.[0]?.croppedImages,
            imageOriginUrl: content?.[0]?.imageOriginUrl
          })  
        
    }

    return {
        ...rest,
        preview: rest?.preview ?? false,
        isPreview: rest?.preview ?? false,
        widgets: rest?.widgets ?? [],
        menu,
        formatContent: {
            content,
            sectionData,
            dataAnalitics,
            dataMeter,
            sectionNameAds,
            adsPath,
            title,
            description,
            tagsRelated,
            manualTagsRelated,
            listado,
            dataMetaTagsSubhome: {
                title: `${metaTitle} - Clarín.com`,
                description: metaDescription,
                url: urlCanonical,
                imageUrl: imagesRelated?.[0]?.url,
                section:  title,
                imageWeb: imageWeb
            },
            dataHeader: {
                liveblogs: bucketsHeader.liveblogs,
                menu,
                sectionData,
                newsToday: menu?.noticiashoy?.item?.items,
            }
        },
    }
}